export default __webpack_public_path__ + "static/media/GatherLogo2White.0c308b15.png";